<template>
  <div class="pageBox">
    <div class="content">
      <div class="dataBox">
        <div class="imgBox">
          <img class="img" :src="this.linkData.appIcon" alt=""/>
        </div>
        <div>
          <p class="appName">{{ linkData.appName }}</p>
          <p>包名：{{ linkData.appPackage }}</p>
        </div>
        <div class="border"></div>
        <div class="linkBox">
          <p>链接名称：{{ linkData.linkName }}</p>
          <p>链接地址：{{ linkData.linkUrl }}</p>
          <p>链接状态：{{ linkData.freezeState == '1' ? '正常' : '冻结' }}</p>
        </div>
      </div>
      <div class="contentBox">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="链接访问" name="linkAccess">
            <linkAccess v-if="activeName=='linkAccess'"></linkAccess>
          </el-tab-pane>
          <el-tab-pane label="链接分发" name="linkDistribute">
            <linkDistribute v-if="activeName=='linkDistribute'"></linkDistribute>
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>
  </div>
</template>

<script>
import linkAccess from "./template/linkAccess.vue"
import linkDistribute from "./template/linkDistribute.vue"

export default {
  components: {linkAccess, linkDistribute},
  data() {
    return {
      activeName: "linkAccess",
      linkData: {},
    }
  },
  created() {
    this.queryLinkDetail();
  },
  methods: {
    // //获取应用信息
    // queryIdentifyLastDetail(){
    //   this.$apis.consoleSever.queryDetail({
    //     id:this.$route.query.appId,
    //   }).then(res=>{
    //     if (res.code == 0) {
    //       this.appDetail=res.data;

    //     }
    //   })
    // },
    //获取链接详情
    queryLinkDetail() {
      this.$apis.consoleSever.queryLinkDetail({
        id: this.$route.query.id
      }).then((res) => {
        if (res.code == 0) {
          this.linkData = res.data;
          // window.$store.commit("breadcrumbStore/setKeyBreadcrumb", {
          //   menu: this.$route.meta.key, 
          //   name:res.data.apkName, 
          //   path: this.$route.fullPath, 
          // });
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.pageBox {
  padding: 20px;
  border-radius: 5px;
  min-height: calc(100% - 94px); //减底部(20px+ICP高度+20px)
  .content {
    background: #fff;
    box-shadow: $--background-shadow-base;
    overflow: hidden;
    padding: 30px;

    .dataBox {
      display: flex;
      align-items: center;
      height: 100px;
      margin-bottom: 20px;

      & > div {
        height: 100%;
        display: flex;
        flex-direction: column;

        p {
          margin-bottom: 8px;
          font-size: 16px;
          height: 30px;
          line-height: 30px;
        }
      }

      .imgBox {
        width: 100px;
        height: 100px;
        border-radius: 10px;
        margin-right: 19px;
        .img {
          width: 100px;
          height: 100px;
        }
      }

      .border {
        width: 1px;
        height: 100%;
        background: #ccc;
        margin: 0 20px;
      }

      .appName {
        font-size: 24px;
        color: #000000;
        font-weight: bold;
        margin-bottom: 8px;
      }
    }
  }
}
</style>
